import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Grid } from "@material-ui/core";
import translate from "../../../../i18n/translate";
import { SrAlert, SrButton, SrInput } from "../../../common";
import { validations } from "utils";

const initialValues = {
  street: "",
  numExt: "",
  numInt: "",
  zipCode: "",
  area: "",
  city: "",
  state: "",
};

const validationSchema = Yup.object().shape({
  street: Yup.string().required(translate("common.requiredField")),
  numExt: Yup.string().required(translate("common.requiredField")),
  numInt: Yup.string().required(translate("common.requiredField")),
  zipCode: validations.zipCode,
  area: Yup.string().required(translate("common.requiredField")),
  city: Yup.string().required(translate("common.requiredField")),
  state: Yup.string().required(translate("common.requiredField")),
});

const StepThree = ({ onSubmit, currentState, setCurrentState, onGoBack }) => (
  <Formik
    initialValues={currentState || initialValues}
    validateOnChange="true"
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ errors, handleBlur, handleChange, touched, values, isSubmitting }) => (
      <Form noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.street")}
              required
              fullWidth
              error={Boolean(errors.street && touched.street)}
              helperText={touched.street && errors.street}
              id="street"
              type="text"
              name="street"
              autoComplete="street"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.street}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.exteriorNumber")}
              required
              fullWidth
              error={Boolean(errors.numExt && touched.numExt)}
              helperText={touched.numExt && errors.numExt}
              name="numExt"
              type="text"
              id="numExt"
              autoComplete="numExt"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.numExt}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.interiorNumber")}
              required
              fullWidth
              error={Boolean(errors.numInt && touched.numInt)}
              helperText={touched.numInt && errors.numInt}
              name="numInt"
              type="text"
              id="numInt"
              autoComplete="numInt"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.numInt}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.zipCode")}
              required
              fullWidth
              error={Boolean(errors.zipCode && touched.zipCode)}
              helperText={touched.zipCode && errors.zipCode}
              name="zipCode"
              type="text"
              inputProps={{ maxLength: 5 }}
              id="zipCode"
              autoComplete="zipCode"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.zipCode}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.area")}
              required
              fullWidth
              error={Boolean(errors.area && touched.area)}
              helperText={touched.area && errors.area}
              name="area"
              type="text"
              id="area"
              autoComplete="area"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.area}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.city")}
              required
              fullWidth
              error={Boolean(errors.city && touched.city)}
              helperText={touched.city && errors.city}
              name="city"
              type="text"
              id="city"
              autoComplete="city"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.city}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInput
              InputLabelProps={{ required: false }}
              variant="outlined"
              label={translate("auth.state")}
              required
              fullWidth
              error={Boolean(errors.state && touched.state)}
              helperText={touched.state && errors.state}
              name="state"
              type="text"
              id="state"
              autoComplete="state"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.state}
            />
          </Grid>
          {errors.main && (
            <Grid item xs={12}>
              <SrAlert severity="error">{errors.main}</SrAlert>
            </Grid>
          )}
          <Grid item xs={12}>
            <SrButton
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              {translate("auth.register")}
            </SrButton>
          </Grid>
          <Grid item xs={12}>
            <SrButton
              onClick={() => {
                setCurrentState(values);
                onGoBack();
              }}
              type="button"
              disabled={isSubmitting}
            >
              {translate("auth.goBack")}
            </SrButton>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
);

export default StepThree;
